<div>
  <app-page-title title="Audit Trail"></app-page-title>
  <div class="my-2 w-full flex items-center px-3">
    <mat-form-field appearance="outline" class="mr-2 col-md-3">
      <mat-label>User</mat-label>
      <mat-select [(ngModel)]="filtering.username" (selectionChange)="onFilterChange()">
        <mat-option [value]="null">All</mat-option>
        @for (user of institutionsUsers$ | async; track user.id) {
          <mat-option value="{{ user?.profile?.userEmail }}">{{ user?.profile?.userEmail }}</mat-option>
        }
        @for (user of users$ | async; track user.id) {
          <mat-option value="{{ user?.userEmail }}">{{ user?.userEmail }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="mr-2 col-md-3">
      <mat-label>Log Type</mat-label>
      <mat-select [(ngModel)]="filtering.logType" (selectionChange)="onFilterChange()">
        <mat-option value="Authentication">Authentication</mat-option>
        <mat-option value="Activity">Activity</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="mr-2 col-md-3">
      <mat-label>Start Date</mat-label>
      <input
        [(ngModel)]="filtering.startDate"
        matInput
        [matDatepicker]="startPicker"
        (dateChange)="onFilterChange()"
      />
      <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="mr-2 col-md-3">
      <mat-label>End Date</mat-label>
      <input
        matInput
        [(ngModel)]="filtering.endDate"
        [matDatepicker]="endPicker"
        (dateChange)="onFilterChange()"
      />
      <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>
  </div>
  <div>
    <app-data-table-hybrid
      *ngIf="auditLogs | async"
      [columnHeader]="tableColumns"
      [tableData]="auditLogs"
      [isPageable]="false"
      [hasActionsColumn]="false"
    >
    </app-data-table-hybrid>
  </div>
</div>
